// Global fix for ResizeObserver error
// This file patches the ResizeObserver to prevent the loop limit error

if (typeof window !== 'undefined') {
  // Save original ResizeObserver
  const OriginalResizeObserver = window.ResizeObserver;

  // Create a patched version that won't throw the loop limit error
  window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        // Prevent the error by not calling the callback if we're not visible
        // This addresses the core issue that causes the loop error
        const shouldCallCallback = entries.some(entry => {
          const rect = entry.contentRect;
          return rect.width > 0 || rect.height > 0;
        });
        
        if (shouldCallCallback) {
          callback(entries, observer);
        }
      });
    }
  };

  // Also catch any errors that might still occur
  const originalConsoleError = console.error;
  console.error = (...args: any[]) => {
    if (
      args.length > 0 &&
      typeof args[0] === 'string' &&
      args[0].includes('ResizeObserver loop') 
    ) {
      // Suppress ResizeObserver loop errors
      return;
    }
    originalConsoleError.apply(console, args);
  };
}

export default {};
